import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Turborepo 2.2",
  "description": "Turborepo 2.2 adds a new command to query your repository, cache safety improvements, and intelligent affected filters.",
  "date": "2024/10/18",
  "tag": "web development"
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Turborepo 2.2 brings a new repository query command, along with other improvements, including:"
  }, {
    "heading": "",
    "content": "Repository queries : Explore your repository like never before with turbo query"
  }, {
    "heading": "",
    "content": "Improved cache safety: Easily diagnose and fix missing environment variable dependencies, and incorrect cache configurations"
  }, {
    "heading": "",
    "content": "Zero-configuration comparisons for affected packages: Automatically target packages with changes in GitHub workflows"
  }, {
    "heading": "",
    "content": "Update today by running npx @turbo/codemod migrate or get started with npx create-turbo@latest."
  }, {
    "heading": "query-your-repository-experimental",
    "content": "In Turborepo 2.2, we're introducing turbo query—a new command that\nallows running GraphQL queries against Turborepo's repository data. Turborepo computes lots of data about your repository\nin order to execute your tasks with maximum efficiency. This includes your package dependency graph, changed packages, task dependencies, log output from your tasks, and more.\nThis data can be useful for scripting, refactoring, determine what to run in CI, and discovering other insights into your codebase."
  }, {
    "heading": "query-your-repository-experimental",
    "content": "To get started, run turbo query to open GraphiQL—a local IDE for writing GraphQL queries\nthat supports interactive schema exploration, documentation, and sending queries."
  }, {
    "heading": "query-your-repository-experimental",
    "content": "You can also pass queries directly as a string or file path:"
  }, {
    "heading": "examples",
    "content": "Get the name and path for all affected packages that have a test task."
  }, {
    "heading": "examples",
    "content": "Get a specific package and its direct dependencies."
  }, {
    "heading": "examples",
    "content": "Find all packages with more than 10 immediate dependents."
  }, {
    "heading": "examples",
    "content": "Turborepo has added APIs for structured data in the past, such as run summaries, dry run, and ls.\nHowever, these APIs have some limitations. First, they're centered around a single run, not general repository info. Second, as we added more fields, the output quickly became very large.\nWe needed a way to query repository data in a run-agnostic fashion, and make the returned data more customizable."
  }, {
    "heading": "examples",
    "content": "We would like to thank @maschwenk, @rafaeltab and @weyert for their early feedback on this feature."
  }, {
    "heading": "examples",
    "content": "To learn more, visit the documentation, and leave feedback for this new experimental command on the turbo query RFC."
  }, {
    "heading": "improved-cache-safety",
    "content": "Caching tasks is one of the most powerful features of Turborepo, speeding up builds and other tasks by only re-running what has changed.\nWith Turborepo 2.2, we're releasing some improvements to help configure cache inputs and outputs, and warn you when things don't look quite correct."
  }, {
    "heading": "platform-environment-variables",
    "content": "When deploying your applications, you likely already have environment variables configured in your production environment. Now, for supported platforms, Turborepo will\nautomatically check these environment variables against your turbo.json configuration to ensure that you've correctly accounted for them,\nand will warn you about any missing environment variables."
  }, {
    "heading": "platform-environment-variables",
    "content": "Any platform can support this feature by implementing the TURBO_PLATFORM_ENV environment variable in to the build environment."
  }, {
    "heading": "platform-environment-variables",
    "content": "Vercel is supported today, and we will update documentation as more platforms become available."
  }, {
    "heading": "platform-environment-variables",
    "content": "Learn more about platform environment variables."
  }, {
    "heading": "warnings-for-empty-cache-configurations",
    "content": "When running tasks, Turborepo will now warn you if a task is configured to cache an empty directory.\nThis can be a common mistake, and can lead to accidental broken builds. This is enabled by default in 2.2."
  }, {
    "heading": "warnings-for-empty-cache-configurations",
    "content": "Learn more about configuring outputs."
  }, {
    "heading": "improvements-to-eslint-config-turbo",
    "content": "Turborepo automatically adds prefix wildcards to your env key for common frameworks.\nIf you're using one of the supported frameworks, you don't need to specify environment variables that begin with the framework's prefix."
  }, {
    "heading": "improvements-to-eslint-config-turbo",
    "content": "Now in Turborepo 2.2, eslint-config-turbo supports this feature as well, ensuring the warnings from the plugin are accurate and actionable."
  }, {
    "heading": "improvements-to-eslint-config-turbo",
    "content": "Learn more about eslint-config-turbo."
  }, {
    "heading": "zero-configuration-comparisons-with---affected",
    "content": "In Turborepo 2.1, we released the --affected flag which can be used with turbo run and turbo ls to automatically target changed packages.\nIn 2.2, we're taking it a step further by introducing automatic comparisons when running --affected in a GitHub workflow—making common use cases even smarter."
  }, {
    "heading": "zero-configuration-comparisons-with---affected",
    "content": "For workflows running in response to a pull request, the base of the comparison is automatically set to the base of the pull request. This ensures turbo considers any files changed in the pull request when determining the affected packages."
  }, {
    "heading": "zero-configuration-comparisons-with---affected",
    "content": "For workflows running in response to a push, the base of the comparison is automatically set to commit before your latest push."
  }, {
    "heading": "zero-configuration-comparisons-with---affected",
    "content": "Learn more about --affected."
  }, {
    "heading": "community",
    "content": "Since releasing Turborepo 2.1 we've seen incredible adoption and community growth:"
  }, {
    "heading": "community",
    "content": "26.2k+ GitHub Stars"
  }, {
    "heading": "community",
    "content": "3.2M+ weekly NPM downloads"
  }, {
    "heading": "community",
    "content": "477 years of compute time saved through Remote Caching on Vercel"
  }, {
    "heading": "community",
    "content": "Turborepo is the result of the combined work of all of its contributors, including our core team."
  }, {
    "heading": "community",
    "content": "View the full changelog."
  }, {
    "heading": "community",
    "content": "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
  }],
  "headings": [{
    "id": "query-your-repository-experimental",
    "content": "Query your repository Experimental"
  }, {
    "id": "examples",
    "content": "Examples"
  }, {
    "id": "improved-cache-safety",
    "content": "Improved cache safety"
  }, {
    "id": "platform-environment-variables",
    "content": "Platform environment variables"
  }, {
    "id": "warnings-for-empty-cache-configurations",
    "content": "Warnings for empty cache configurations"
  }, {
    "id": "improvements-to-eslint-config-turbo",
    "content": "Improvements to eslint-config-turbo"
  }, {
    "id": "zero-configuration-comparisons-with---affected",
    "content": "Zero-configuration comparisons with --affected"
  }, {
    "id": "community",
    "content": "Community"
  }]
};
import {Authors} from '#components/authors';
import {Date} from '#components/blog/date';
import {Callout} from '#components/callout';
import {ExperimentalBadge} from '#components/experimental-badge';
export const toc = [{
  depth: 2,
  url: "#query-your-repository-experimental",
  title: _jsxs(_Fragment, {
    children: ["Query your repository ", _jsx(ExperimentalBadge, {
      children: "Experimental"
    })]
  })
}, {
  depth: 3,
  url: "#examples",
  title: _jsx(_Fragment, {
    children: "Examples"
  })
}, {
  depth: 2,
  url: "#improved-cache-safety",
  title: _jsx(_Fragment, {
    children: "Improved cache safety"
  })
}, {
  depth: 3,
  url: "#platform-environment-variables",
  title: _jsx(_Fragment, {
    children: "Platform environment variables"
  })
}, {
  depth: 3,
  url: "#warnings-for-empty-cache-configurations",
  title: _jsx(_Fragment, {
    children: "Warnings for empty cache configurations"
  })
}, {
  depth: 3,
  url: "#improvements-to-eslint-config-turbo",
  title: _jsxs(_Fragment, {
    children: ["Improvements to ", _jsx("code", {
      children: "eslint-config-turbo"
    })]
  })
}, {
  depth: 2,
  url: "#zero-configuration-comparisons-with---affected",
  title: _jsxs(_Fragment, {
    children: ["Zero-configuration comparisons with ", _jsx("code", {
      children: "--affected"
    })]
  })
}, {
  depth: 2,
  url: "#community",
  title: _jsx(_Fragment, {
    children: "Community"
  })
}];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    code: "code",
    h2: "h2",
    h3: "h3",
    li: "li",
    p: "p",
    pre: "pre",
    span: "span",
    strong: "strong",
    ul: "ul",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx("h1", {
      className: "text-center",
      children: "Turborepo 2.2"
    }), "\n", "\n", _jsx(Date, {
      children: "Friday, October 18th, 2024"
    }), "\n", _jsx(Authors, {
      authors: ['tomknickman', 'anthonyshew', 'chrisolszewski', 'nicholasyang', 'dimitrimitropoulos']
    }), "\n", _jsx(_components.p, {
      children: "Turborepo 2.2 brings a new repository query command, along with other improvements, including:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsxs(_components.a, {
          href: "#query-your-repository-experimental",
          children: [_jsx(_components.strong, {
            children: "Repository queries"
          }), " ", _jsx(ExperimentalBadge, {
            isLink: false
          })]
        }), ": Explore your repository like never before with ", _jsx(_components.code, {
          children: "turbo query"
        })]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#improved-cache-safety",
          children: _jsx(_components.strong, {
            children: "Improved cache safety"
          })
        }), ": Easily diagnose and fix missing environment variable dependencies, and incorrect cache configurations"]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.a, {
          href: "#zero-configuration-comparisons-with---affected",
          children: _jsx(_components.strong, {
            children: "Zero-configuration comparisons for affected packages"
          })
        }), ": Automatically target packages with changes in GitHub workflows"]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Update today by running ", _jsx(_components.code, {
        children: "npx @turbo/codemod migrate"
      }), " or get started with ", _jsx(_components.code, {
        children: "npx create-turbo@latest"
      }), "."]
    }), "\n", _jsxs(_components.h2, {
      id: "query-your-repository-experimental",
      children: ["Query your repository ", _jsx(ExperimentalBadge, {
        children: "Experimental"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["In Turborepo 2.2, we're introducing ", _jsx(_components.a, {
        href: "/docs/reference/query",
        children: _jsx(_components.code, {
          children: "turbo query"
        })
      }), "—a new command that\nallows running ", _jsx(_components.a, {
        href: "https://graphql.org/",
        children: "GraphQL"
      }), " queries against Turborepo's repository data. Turborepo computes lots of data about your repository\nin order to execute your tasks with maximum efficiency. This includes your package dependency graph, changed packages, task dependencies, log output from your tasks, and more.\nThis data can be useful for scripting, refactoring, determine what to run in CI, and discovering other insights into your codebase."]
    }), "\n", _jsxs(_components.p, {
      children: ["To get started, run ", _jsx(_components.code, {
        children: "turbo query"
      }), " to open GraphiQL—a local IDE for writing GraphQL queries\nthat supports interactive schema exploration, documentation, and sending queries."]
    }), "\n", _jsx(_components.p, {
      children: "You can also pass queries directly as a string or file path:"
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "Terminal",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"m 4,4 a 1,1 0 0 0 -0.7070312,0.2929687 1,1 0 0 0 0,1.4140625 L 8.5859375,11 3.2929688,16.292969 a 1,1 0 0 0 0,1.414062 1,1 0 0 0 1.4140624,0 l 5.9999998,-6 a 1.0001,1.0001 0 0 0 0,-1.414062 L 4.7070312,4.2929687 A 1,1 0 0 0 4,4 Z m 8,14 a 1,1 0 0 0 -1,1 1,1 0 0 0 1,1 h 8 a 1,1 0 0 0 1,-1 1,1 0 0 0 -1,-1 z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " query"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: " \"query { package(name: \\\"web\\\") { name } }\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-function)",
                "--shiki-dark": "var(--shiki-token-function)"
              },
              children: "turbo"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " query"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: " query.gql"
            })]
          })]
        })
      })
    }), "\n", _jsx(_components.h3, {
      id: "examples",
      children: "Examples"
    }), "\n", _jsxs(_components.p, {
      children: ["Get the name and path for all ", _jsx(_components.a, {
        href: "/docs/reference/run#--affected",
        children: "affected packages"
      }), " that have a ", _jsx(_components.code, {
        children: "test"
      }), " task."]
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "affected-packages.gql",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M12.002 0a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm8.54 4.931a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm0 9.862a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm-8.54 4.931a2.138 2.138 0 1 0 0 4.276 2.138 2.138 0 1 0 0-4.276zm-8.542-4.93a2.138 2.138 0 1 0 0 4.276 2.138 2.138 0 1 0 0-4.277zm0-9.863a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm8.542-3.378L2.953 6.777v10.448l9.049 5.224 9.047-5.224V6.777zm0 1.601 7.66 13.27H4.34zm-1.387.371L3.97 15.037V7.363zm2.774 0 6.646 3.838v7.674zM5.355 17.44h13.293l-6.646 3.836z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "{"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  affectedPackages("
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    base: "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"main\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    head: "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"HEAD\""
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    filter: { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "has"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "field"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": TASK_NAME, "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "value"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"test\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " } }"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  ) {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    items {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      name"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      path"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "Get a specific package and its direct dependencies."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "direct-dependencies.gql",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M12.002 0a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm8.54 4.931a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm0 9.862a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm-8.54 4.931a2.138 2.138 0 1 0 0 4.276 2.138 2.138 0 1 0 0-4.276zm-8.542-4.93a2.138 2.138 0 1 0 0 4.276 2.138 2.138 0 1 0 0-4.277zm0-9.863a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm8.542-3.378L2.953 6.777v10.448l9.049 5.224 9.047-5.224V6.777zm0 1.601 7.66 13.27H4.34zm-1.387.371L3.97 15.037V7.363zm2.774 0 6.646 3.838v7.674zM5.355 17.44h13.293l-6.646 3.836z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "query"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  package(name: "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string-expression)",
                "--shiki-dark": "var(--shiki-token-string-expression)"
              },
              children: "\"cli\""
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ") {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    directDependencies {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "      name"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsx(_components.p, {
      children: "Find all packages with more than 10 immediate dependents."
    }), "\n", _jsx(_Fragment, {
      children: _jsx(_components.pre, {
        className: "shiki shiki-themes css-variables css-variables",
        style: {
          "--shiki-light": "var(--shiki-foreground)",
          "--shiki-dark": "var(--shiki-foreground)",
          "--shiki-light-bg": "var(--shiki-background)",
          "--shiki-dark-bg": "var(--shiki-background)"
        },
        tabIndex: "0",
        title: "filter.gql",
        icon: "<svg viewBox=\"0 0 24 24\"><path d=\"M12.002 0a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm8.54 4.931a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm0 9.862a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm-8.54 4.931a2.138 2.138 0 1 0 0 4.276 2.138 2.138 0 1 0 0-4.276zm-8.542-4.93a2.138 2.138 0 1 0 0 4.276 2.138 2.138 0 1 0 0-4.277zm0-9.863a2.138 2.138 0 1 0 0 4.277 2.138 2.138 0 1 0 0-4.277zm8.542-3.378L2.953 6.777v10.448l9.049 5.224 9.047-5.224V6.777zm0 1.601 7.66 13.27H4.34zm-1.387.371L3.97 15.037V7.363zm2.774 0 6.646 3.838v7.674zM5.355 17.44h13.293l-6.646 3.836z\" fill=\"currentColor\" /></svg>",
        children: _jsxs(_components.code, {
          children: [_jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-keyword)",
                "--shiki-dark": "var(--shiki-token-keyword)"
              },
              children: "query"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " {"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  packages("
            })
          }), "\n", _jsxs(_components.span, {
            className: "line",
            children: [_jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    filter: { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "greaterThan"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": { "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "field"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": DIRECT_DEPENDENT_COUNT, "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-string)",
                "--shiki-dark": "var(--shiki-token-string)"
              },
              children: "value"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: ": "
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-token-constant)",
                "--shiki-dark": "var(--shiki-token-constant)"
              },
              children: "10"
            }), _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: " } }"
            })]
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  ) {"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "    name"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "  }"
            })
          }), "\n", _jsx(_components.span, {
            className: "line",
            children: _jsx(_components.span, {
              style: {
                "--shiki-light": "var(--shiki-foreground)",
                "--shiki-dark": "var(--shiki-foreground)"
              },
              children: "}"
            })
          })]
        })
      })
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo has added APIs for structured data in the past, such as ", _jsx(_components.a, {
        href: "/docs/reference/run#--summarize",
        children: "run summaries"
      }), ", ", _jsx(_components.a, {
        href: "/docs/reference/run#--dry----dry-run",
        children: "dry run"
      }), ", and ", _jsx(_components.a, {
        href: "/docs/reference/ls",
        children: _jsx(_components.code, {
          children: "ls"
        })
      }), ".\nHowever, these APIs have some limitations. First, they're centered around a single run, not general repository info. Second, as we added more fields, the output quickly became very large.\nWe needed a way to query repository data in a run-agnostic fashion, and make the returned data more customizable."]
    }), "\n", _jsxs(_components.p, {
      children: ["We would like to thank ", _jsx(_components.a, {
        href: "https://github.com/maschwenk",
        children: "@maschwenk"
      }), ", ", _jsx(_components.a, {
        href: "https://github.com/rafaeltab",
        children: "@rafaeltab"
      }), " and ", _jsx(_components.a, {
        href: "https://github.com/weyert",
        children: "@weyert"
      }), " for their early feedback on this feature."]
    }), "\n", _jsxs(_components.p, {
      children: ["To learn more, ", _jsx(_components.a, {
        href: "/docs/reference/query",
        children: "visit the documentation"
      }), ", and leave feedback for this new experimental command on the ", _jsx(_components.code, {
        children: "turbo query"
      }), " ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/discussions/9170",
        children: "RFC"
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "improved-cache-safety",
      children: "Improved cache safety"
    }), "\n", _jsx(_components.p, {
      children: "Caching tasks is one of the most powerful features of Turborepo, speeding up builds and other tasks by only re-running what has changed.\nWith Turborepo 2.2, we're releasing some improvements to help configure cache inputs and outputs, and warn you when things don't look quite correct."
    }), "\n", _jsx(_components.h3, {
      id: "platform-environment-variables",
      children: "Platform environment variables"
    }), "\n", _jsxs(_components.p, {
      children: ["When deploying your applications, you likely already have environment variables configured in your production environment. Now, for supported platforms, Turborepo will\nautomatically check these environment variables against your ", _jsx(_components.code, {
        children: "turbo.json"
      }), " configuration to ensure that you've correctly ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#adding-environment-variables-to-task-hashes",
        children: "accounted for them"
      }), ",\nand will warn you about any missing environment variables."]
    }), "\n", _jsxs(_components.p, {
      children: ["Any platform can support this feature by implementing the ", _jsx(_components.a, {
        href: "/docs/reference/system-environment-variables",
        children: _jsx(_components.code, {
          children: "TURBO_PLATFORM_ENV"
        })
      }), " environment variable in to the build environment."]
    }), "\n", _jsxs(_components.p, {
      children: [_jsx(_components.a, {
        href: "https://vercel.com",
        children: "Vercel"
      }), " is supported today, and we will update documentation as more platforms become available."]
    }), "\n", _jsxs(_components.p, {
      children: ["Learn more about ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#platform-environment-variables",
        children: "platform environment variables"
      }), "."]
    }), "\n", _jsx(_components.h3, {
      id: "warnings-for-empty-cache-configurations",
      children: "Warnings for empty cache configurations"
    }), "\n", _jsx(_components.p, {
      children: "When running tasks, Turborepo will now warn you if a task is configured to cache an empty directory.\nThis can be a common mistake, and can lead to accidental broken builds. This is enabled by default in 2.2."
    }), "\n", _jsxs(_components.p, {
      children: ["Learn more about ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/configuring-tasks#specifying-outputs",
        children: "configuring outputs"
      }), "."]
    }), "\n", _jsxs(_components.h3, {
      id: "improvements-to-eslint-config-turbo",
      children: ["Improvements to ", _jsx(_components.code, {
        children: "eslint-config-turbo"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo automatically adds prefix wildcards to your env key for ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/using-environment-variables#framework-inference",
        children: "common frameworks"
      }), ".\nIf you're using one of the supported frameworks, you don't need to specify environment variables that begin with the framework's prefix."]
    }), "\n", _jsxs(_components.p, {
      children: ["Now in Turborepo 2.2, ", _jsx(_components.code, {
        children: "eslint-config-turbo"
      }), " supports this feature as well, ensuring the warnings from the plugin are accurate and actionable."]
    }), "\n", _jsxs(_components.p, {
      children: ["Learn more about ", _jsx(_components.a, {
        href: "/docs/reference/eslint-config-turbo",
        children: _jsx(_components.code, {
          children: "eslint-config-turbo"
        })
      }), "."]
    }), "\n", _jsxs(_components.h2, {
      id: "zero-configuration-comparisons-with---affected",
      children: ["Zero-configuration comparisons with ", _jsx(_components.code, {
        children: "--affected"
      })]
    }), "\n", _jsxs(_components.p, {
      children: ["In Turborepo 2.1, we released the ", _jsx(_components.a, {
        href: "/docs/reference/run#--affected",
        children: _jsx(_components.code, {
          children: "--affected"
        })
      }), " flag which can be used with ", _jsx(_components.a, {
        href: "/docs/reference/run",
        children: _jsx(_components.code, {
          children: "turbo run"
        })
      }), " and ", _jsx(_components.a, {
        href: "/docs/reference/ls",
        children: _jsx(_components.code, {
          children: "turbo ls"
        })
      }), " to automatically target changed packages.\nIn 2.2, we're taking it a step further by introducing automatic comparisons when running ", _jsx(_components.a, {
        href: "/docs/reference/run#--affected",
        children: _jsx(_components.code, {
          children: "--affected"
        })
      }), " in a GitHub workflow—making common use cases even smarter."]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: ["For workflows running in response to a ", _jsx(_components.a, {
          href: "https://docs.github.com/en/actions/writing-workflows/choosing-when-your-workflow-runs/events-that-trigger-workflows#pull_request",
          children: "pull request"
        }), ", the base of the comparison is automatically set to the base of the pull request. This ensures ", _jsx(_components.code, {
          children: "turbo"
        }), " considers any files changed in the pull request when determining the affected packages."]
      }), "\n", _jsxs(_components.li, {
        children: ["For workflows running in response to a ", _jsx(_components.a, {
          href: "https://docs.github.com/en/actions/writing-workflows/choosing-when-your-workflow-runs/events-that-trigger-workflows#push",
          children: "push"
        }), ", the base of the comparison is automatically set to commit before your latest push."]
      }), "\n"]
    }), "\n", _jsxs(_components.p, {
      children: ["Learn more about ", _jsx(_components.a, {
        href: "/docs/crafting-your-repository/constructing-ci#using---affected-in-github-actions",
        children: _jsx(_components.code, {
          children: "--affected"
        })
      }), "."]
    }), "\n", _jsx(_components.h2, {
      id: "community",
      children: "Community"
    }), "\n", _jsxs(_components.p, {
      children: ["Since releasing ", _jsx(_components.a, {
        href: "/blog/turbo-2-1-0",
        children: "Turborepo 2.1"
      }), " we've seen incredible adoption and community growth:"]
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://github.com/vercel/turbo",
          children: "26.2k+ GitHub Stars"
        })
      }), "\n", _jsx(_components.li, {
        children: _jsx(_components.a, {
          href: "https://www.npmjs.com/package/turbo",
          children: "3.2M+ weekly NPM downloads"
        })
      }), "\n", _jsxs(_components.li, {
        children: ["477 years of compute time saved through ", _jsx(_components.a, {
          href: "https://vercel.com/docs/concepts/monorepos/remote-caching",
          children: "Remote Caching on Vercel"
        })]
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "Turborepo is the result of the combined work of all of its contributors, including our core team."
    }), "\n", _jsxs(_components.p, {
      children: ["View the full ", _jsx(_components.a, {
        href: "https://github.com/vercel/turborepo/releases/tag/v2.2.0",
        children: "changelog"
      }), "."]
    }), "\n", _jsx(_components.p, {
      children: "Thank you for your continued support, feedback, and collaboration to make Turborepo your build tool of choice."
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
